<template>
    <!-- Dashboard Sidebar
    ================================================== -->
    <div class="dashboard-sidebar hidden-xs hidden-md">
        <div class="dashboard-sidebar-inner">
            <div class="dashboard-nav-container ">


                <div class="dashboard-nav ">
                    <div class="dashboard-nav-inner">

                        <ul data-submenu-title="" v-if="$root.user.tipo == 'contratante' && $root.config['menu']">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].paciente.dicasSemanais" v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].paciente.meusAgendamentos" v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="static/images/icones/calendar.png"> Meus agendamentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].paciente.agendarConsulta" v-bind:class="{'active': $router.currentRoute.name == 'Profissionais'}">
                                <router-link :to="{'name': 'Profissionais'}">
                                    <img src="static/images/icones/stethoscope.png"> Agendar consulta
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].paciente.receitasAtestados" v-bind:class="{'active': $router.currentRoute.name == 'Receitas'}">
                                <router-link :to="{'name': 'Receitas'}">
                                    <img src="static/images/icones/note.png"> Receitas e atestados
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].paciente.meusExames" v-bind:class="{'active': $router.currentRoute.name == 'Exames'}">
                                <router-link :to="{'name': 'Exames'}">
                                    <img src="static/images/icones/archives.png"> Meus exames
                                </router-link>
                            </li>   
                            <li v-if="$root.config['menu'].paciente.meusDocumentos" v-bind:class="{'active': $router.currentRoute.name == 'Arquivos'}">
                                <router-link :to="{'name': 'Arquivos'}">
                                    <img src="static/images/icones/diary.png"> Meus documentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].paciente.ged" v-bind:class="{'active': $router.currentRoute.name == 'Ged'}">
                                <router-link :to="{'name': 'Ged'}">
                                    <img src="static/images/icones/diary.png"> GED
                                </router-link>
                            </li>                            
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].paciente.minhaConta" v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                              
                        </ul>

                        <ul data-submenu-title="" v-if="$root.user.tipo == 'profissional' && $root.config['menu']">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].profissional.agendamentos" v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="static/images/icones/calendar.png"> Agendamentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].profissional.pacientes" v-bind:class="{'active': $router.currentRoute.name == 'Pacientes'}">
                                <router-link :to="{'name': 'Pacientes'}">
                                    <img src="static/images/icones/users.png"> Pacientes
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].profissional.honorariosMedicos" v-bind:class="{'active': $router.currentRoute.name == 'HonorariosMedicos'}">
                                <router-link :to="{'name': 'HonorariosMedicos'}">
                                    <img src="static/images/icones/wallet.png"> Honorários médicos
                                </router-link>
                            </li>                            
                            <li v-if="$root.config['menu'].profissional.receitasAtestados" v-bind:class="{'active': $router.currentRoute.name == 'Receitas'}">
                                <router-link :to="{'name': 'Receitas'}">
                                    <img src="static/images/icones/note.png"> Receitas e atestados
                                </router-link>
                            </li>             
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].profissional.minhaConta" v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                              
                        </ul>
                       
                        <ul data-submenu-title="" v-if="$root.user.tipo == 'admin'">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'PendentesFormularios'}">
                                <router-link :to="{'name': 'PendentesFormularios'}">
                                    <img src="static/images/icones/crisis.png"> Formulários pendentes
                                </router-link>
                            </li>                              
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>                            
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="static/images/icones/calendar.png"> Agendamentos
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Pacientes'}">
                                <router-link :to="{'name': 'Pacientes'}">
                                    <img src="static/images/icones/users.png"> Pacientes
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Campanhas'}">
                                <router-link :to="{'name': 'Campanhas'}">
                                    <img src="static/images/icones/tick.png"> Campanhas
                                </router-link>
                            </li> 
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Mural'}">
                                <router-link :to="{'name': 'Mural'}">
                                    <img src="static/images/icones/document.png"> Mural de recados
                                </router-link>
                            </li>   
                            <!-- <li v-bind:class="{'active': $router.currentRoute.name == 'Relatorios'}">
                                <router-link :to="{'name': 'Relatorios'}">
                                    <img src="static/images/icones/page.png"> Relatórios
                                </router-link>
                            </li>  -->                          
                            <li v-bind:class="{'active': $router.currentRoute.name == 'UsuariosGeral'}">
                                <router-link :to="{'name': 'UsuariosGeral'}">
                                    <img src="static/images/icones/user2.png"> Usuários
                                </router-link>
                            </li>    
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Configuracoes'}">
                                <router-link :to="{'name': 'Configuracoes'}">
                                    <img src="static/images/icones/gear.png"> Configurações
                                </router-link>
                            </li>      
                            <li v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroSolicitacoes'}">
                                <router-link :to="{'name': 'FinanceiroSolicitacoes'}">
                                    <img src="static/images/icones/receipt.png"> Aprovações
                                </router-link>
                            </li>  
                            <li v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroMovimentacoes'}">
                                <router-link :to="{'name': 'FinanceiroMovimentacoes'}">
                                    <img src="static/images/icones/refund.png"> Orçamento
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'HonorariosMedicos'}">
                                <router-link :to="{'name': 'HonorariosMedicos'}">
                                    <img src="static/images/icones/wallet.png"> Honorários médicos
                                </router-link>
                            </li>   
                            <li v-bind:class="{'active': $router.currentRoute.name == 'RelatorioFormularios'}">
                                <router-link :to="{'name': 'RelatorioFormularios'}">
                                    <img src="static/images/icones/research.png"> Relatório de formulários
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Formularios'}">
                                <router-link :to="{'name': 'Formularios'}">
                                    <img src="static/images/icones/engineering.png"> Gerenciar formulários
                                </router-link>
                            </li>                                           
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                              
                        </ul>

                       
                        <ul data-submenu-title="" v-if="$root.user.tipo == 'criacao'">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>                          
                            <li v-bind:class="{'active': $router.currentRoute.name == 'UsuariosGeral'}">
                                <router-link :to="{'name': 'UsuariosGeral'}">
                                    <img src="static/images/icones/user2.png"> Usuários
                                </router-link>
                            </li>                                                                           
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                              
                        </ul>

                        <ul data-submenu-title="" v-if="$root.user.tipo == 'coordenador'">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.dicasSemanais" v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.meusAgendamentos" v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="static/images/icones/calendar.png"> Meus agendamentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.agendarConsulta" v-bind:class="{'active': $router.currentRoute.name == 'Profissionais'}">
                                <router-link :to="{'name': 'Profissionais'}">
                                    <img src="static/images/icones/stethoscope.png"> Agendar consulta
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.receitasAtestados" v-bind:class="{'active': $router.currentRoute.name == 'Receitas'}">
                                <router-link :to="{'name': 'Receitas'}">
                                    <img src="static/images/icones/note.png"> Receitas e atestados
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.meusExames" v-bind:class="{'active': $router.currentRoute.name == 'Exames'}">
                                <router-link :to="{'name': 'Exames'}">
                                    <img src="static/images/icones/archives.png"> Meus exames
                                </router-link>
                            </li>   
                            <li v-if="$root.config['menu'].coordenador.meusDocumentos" v-bind:class="{'active': $router.currentRoute.name == 'Arquivos'}">
                                <router-link :to="{'name': 'Arquivos'}">
                                    <img src="static/images/icones/diary.png"> Meus documentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.ged" v-bind:class="{'active': $router.currentRoute.name == 'Ged'}">
                                <router-link :to="{'name': 'Ged'}">
                                    <img src="static/images/icones/diary.png"> GED
                                </router-link>
                            </li>   
                            <li v-if="$root.config['menu'].coordenador.pacientes" v-bind:class="{'active': $router.currentRoute.name == 'Pacientes'}">
                                <router-link :to="{'name': 'Pacientes'}">
                                    <img src="static/images/icones/users.png"> Pacientes
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.aprovacaoOrcamentaria" v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroSolicitacoes'}">
                                <router-link :to="{'name': 'FinanceiroSolicitacoes'}">
                                    <img src="static/images/icones/receipt.png"> Aprovações
                                </router-link>
                            </li>  
                            <li v-if="$root.config['menu'].coordenador.alteracaoOrcamentaria" v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroMovimentacoes'}">
                                <router-link :to="{'name': 'FinanceiroMovimentacoes'}">
                                    <img src="static/images/icones/refund.png"> Orçamento
                                </router-link>
                            </li>   
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].coordenador.minhaConta" v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                              
                        </ul>                        


                        <ul data-submenu-title="" v-if="$root.user.tipo == 'controladoria'">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.dicasSemanais" v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.meusAgendamentos" v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="static/images/icones/calendar.png"> Meus agendamentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.agendarConsulta" v-bind:class="{'active': $router.currentRoute.name == 'Profissionais'}">
                                <router-link :to="{'name': 'Profissionais'}">
                                    <img src="static/images/icones/stethoscope.png"> Agendar consulta
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.receitasAtestados" v-bind:class="{'active': $router.currentRoute.name == 'Receitas'}">
                                <router-link :to="{'name': 'Receitas'}">
                                    <img src="static/images/icones/note.png"> Receitas e atestados
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.meusExames" v-bind:class="{'active': $router.currentRoute.name == 'Exames'}">
                                <router-link :to="{'name': 'Exames'}">
                                    <img src="static/images/icones/archives.png"> Meus exames
                                </router-link>
                            </li>   
                            <li v-if="$root.config['menu'].controladoria.meusDocumentos" v-bind:class="{'active': $router.currentRoute.name == 'Arquivos'}">
                                <router-link :to="{'name': 'Arquivos'}">
                                    <img src="static/images/icones/diary.png"> Meus documentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.ged" v-bind:class="{'active': $router.currentRoute.name == 'Ged'}">
                                <router-link :to="{'name': 'Ged'}">
                                    <img src="static/images/icones/diary.png"> GED
                                </router-link>
                            </li>   
                            <li v-if="$root.config['menu'].controladoria.pacientes" v-bind:class="{'active': $router.currentRoute.name == 'Pacientes'}">
                                <router-link :to="{'name': 'Pacientes'}">
                                    <img src="static/images/icones/users.png"> Pacientes
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.aprovacaoOrcamentaria" v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroSolicitacoes'}">
                                <router-link :to="{'name': 'FinanceiroSolicitacoes'}">
                                    <img src="static/images/icones/receipt.png"> Aprovações
                                </router-link>
                            </li>  
                            <li v-if="$root.config['menu'].controladoria.alteracaoOrcamentaria" v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroMovimentacoes'}">
                                <router-link :to="{'name': 'FinanceiroMovimentacoes'}">
                                    <img src="static/images/icones/refund.png"> Orçamento
                                </router-link>
                            </li>   
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].controladoria.minhaConta" v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                              
                        </ul>                        


                        <ul data-submenu-title="" v-if="$root.user.tipo == 'gerente'">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.dicasSemanais" v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.meusAgendamentos" v-bind:class="{'active': $router.currentRoute.name == 'Agendamentos'}">
                                <router-link :to="{'name': 'Agendamentos'}">
                                    <img src="static/images/icones/calendar.png"> Meus agendamentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.agendarConsulta" v-bind:class="{'active': $router.currentRoute.name == 'Profissionais'}">
                                <router-link :to="{'name': 'Profissionais'}">
                                    <img src="static/images/icones/stethoscope.png"> Agendar consulta
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.receitasAtestados" v-bind:class="{'active': $router.currentRoute.name == 'Receitas'}">
                                <router-link :to="{'name': 'Receitas'}">
                                    <img src="static/images/icones/note.png"> Receitas e atestados
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.meusExames" v-bind:class="{'active': $router.currentRoute.name == 'Exames'}">
                                <router-link :to="{'name': 'Exames'}">
                                    <img src="static/images/icones/archives.png"> Meus exames
                                </router-link>
                            </li>   
                            <li v-if="$root.config['menu'].gerente.meusDocumentos" v-bind:class="{'active': $router.currentRoute.name == 'Arquivos'}">
                                <router-link :to="{'name': 'Arquivos'}">
                                    <img src="static/images/icones/diary.png"> Meus documentos
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.ged" v-bind:class="{'active': $router.currentRoute.name == 'Ged'}">
                                <router-link :to="{'name': 'Ged'}">
                                    <img src="static/images/icones/diary.png"> GED
                                </router-link>
                            </li>   
                            <li v-if="$root.config['menu'].gerente.pacientes" v-bind:class="{'active': $router.currentRoute.name == 'Pacientes'}">
                                <router-link :to="{'name': 'Pacientes'}">
                                    <img src="static/images/icones/users.png"> Pacientes
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.aprovacaoOrcamentaria" v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroSolicitacoes'}">
                                <router-link :to="{'name': 'FinanceiroSolicitacoes'}">
                                    <img src="static/images/icones/receipt.png"> Aprovações
                                </router-link>
                            </li>  
                            <li v-if="$root.config['menu'].gerente.alteracaoOrcamentaria" v-bind:class="{'active': $router.currentRoute.name == 'FinanceiroMovimentacoes'}">
                                <router-link :to="{'name': 'FinanceiroMovimentacoes'}">
                                    <img src="static/images/icones/refund.png"> Orçamento
                                </router-link>
                            </li>   
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].gerente.minhaConta" v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                              
                        </ul>                        


                        <ul data-submenu-title="" v-if="$root.user.tipo == 'marketing' && $root.config['menu']">       
                            <center>
                                <img src="static/config/logo.png" class="logo-sidebar" style="width: 70%">
                            </center>
                            <li v-bind:class="{'active': $router.currentRoute.name == 'Dashboard'}">
                                <router-link :to="{'name': 'Dashboard'}">
                                    <img src="static/images/icones/squares.png"> Início
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].marketing.dicasSemanais" v-bind:class="{'active': $router.currentRoute.name == 'Posts'}">
                                <router-link :to="{'name': 'Posts'}">
                                    <img src="static/images/icones/writing.png"> Dicas semanais
                                </router-link>
                            </li>                            
                            <li v-if="$root.config['menu'].marketing.campanhas" v-bind:class="{'active': $router.currentRoute.name == 'Campanhas'}">
                                <router-link :to="{'name': 'Campanhas'}">
                                    <img src="static/images/icones/tick.png"> Campanhas
                                </router-link>
                            </li> 
                            <li v-if="$root.config['menu'].marketing.muralRecados" v-bind:class="{'active': $router.currentRoute.name == 'Mural'}">
                                <router-link :to="{'name': 'Mural'}">
                                    <img src="static/images/icones/document.png"> Mural de recados
                                </router-link>
                            </li>                                                
                            <li v-bind:class="{'active': $router.currentRoute.name == 'AlterarSenha'}" v-if="$root.logged">
                                <router-link :to="{'name': 'AlterarSenha'}">
                                    <img src="static/images/icones/user.png"> Alterar senha
                                </router-link>
                            </li>
                            <li v-if="$root.config['menu'].marketing.minhaConta" v-bind:class="{'active': $router.currentRoute.name == 'Conta'}">
                                <router-link :to="{'name': 'Conta'}">
                                    <img src="static/images/icones/profile.png"> Minha conta
                                </router-link>
                            </li>
                            <li>
                                <a onclick="window.__app.logout()" v-if="$root.logged">
                                    Sair
                                </a>
                            </li>
                            <li>
                                <a style="font-size: 14px;" :href="$root.config.site" target="_blank">
                                    Acessar site
                                </a>
                            </li>  
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-termos-de-uso')">
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a class="modal-open" style="font-size: 14px;" onclick="window.__app.openModal('modal-politicas-de-privacidade')">
                                    Políticas de privacidade
                                </a>
                            </li>                                                                            
                        </ul>

                    </div>
                </div>
                

            </div>
        </div>
    </div>
   
</template>

<script>
export default {
    name: 'Sidebar',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue